import { ChevronLeft, Close } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { EconomicsPricesSpreadsheet } from "./EconomicsPricesSpreadsheet";

export const EditPriceData = ({ priceData, setEditPriceVisible }) => {
  return (
    <Dialog
      open={true} 
      onClose={() => setEditPriceVisible(false)}
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <IconButton onClick={() => setEditPriceVisible(false)}>
              <ChevronLeft />
            </IconButton>
            <Typography variant="h6">
              Edit Prices
            </Typography>
          </div>
          <IconButton onClick={() => setEditPriceVisible(false)}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{display: 'flex', overflow: 'scroll', width: '100%', height: '100%'}}>
        <EconomicsPricesSpreadsheet priceData={priceData} setPriceData={() => {}} />
      </DialogContent>
      <DialogActions style={{display: 'flex', justifyContent: 'space-between'}}>
        <Button onClick={() => setEditPriceVisible(false)} color="primary">
          Cancel
        </Button>
        <Button variant="contained" onClick={() => {}} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};